import router from '../router';
import store from '../store';

export function setDocumentTitle(meta_title = router.currentRoute.value?.meta?.title, state = store.state) {
   let title = meta_title as string;
   const param_length = ((meta_title as string)?.match(/{/g) || [])?.length;

   for (let i = param_length; i > 0; i--) {
      const param = title.substring(title.indexOf('{') + 1, title.indexOf('}'));
      let state_value = state;

      for (let i = 0; i < param.split('.').length; i++) {
         state_value = state_value ? state_value[param.split('.')[i]] : '';
      }

      title = title.replace(`{${param}}`, state_value);
   }

   document.title =
      window.location.hostname.includes('bussup') || window.location.hostname.includes('localhost')
         ? window.location.hostname.split('-planning-consultant-ui')[0] + ' - ' + title
         : title;
}
